/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface UploadLinkResponse {
  org_name: string;
  member_name: string;
  requester_name: string | null;
  expires_at: string;
}
